import React from 'react';
import styled from '@emotion/styled';
import Image from '@atlaskit/image';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var IconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left'
});
export var ICON_TYPE_TEST_ID = 'link-datasource-render-type--icon';
var IconRenderType = function IconRenderType(_ref) {
  var label = _ref.label,
    source = _ref.source,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? ICON_TYPE_TEST_ID : _ref$testId;
  return /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(Image, {
    src: source,
    alt: label,
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: {
      minWidth: '20px',
      maxWidth: '20px'
    } // having just width: '20px' shrinks it when table width is reduced
  }));
};
export default IconRenderType;